import axios from 'axios';

export default {
    namespaced: true,

    state: () => ({
        cities: [],
        points: [],
        loadingCities: false,
    }),

    getters: {
        getCities: state => state.cities,
        getPoints: state => state.points,
        isCitiesLoading: state => state.loadingCities,
    },

    mutations: {
        setCities(state, cities) {
            state.cities = cities;
        },
        clearCities(state) {
            state.cities = [];
        },
        setPoints(state, points) {
            state.points = points;
        },
        clearPoints(state) {
            state.points = [];
        },
        setCitiesLoading(state, value) {
            state.loadingCities = value;
        },
    },

    actions: {

        async searchCities({ commit }, {
            name,
            country_codes = 'RU',
            size = 10,
            lang = 'ru',
        }) {
            if (!name || name.length < 2) {
                commit('setCities', []);
                return;
            }

            commit('setCitiesLoading', true);

            try {
                const { data } = await axios.get('/cargo/cities/suggest', {
                    params: { name, country_codes, size, lang }
                });

                commit('setCities', data);
            } finally {
                commit('setCitiesLoading', false);
            }
        },

        async fetchPoints({ commit }, params) {
            const { data } = await axios.get('/cargo/points', { params });
            commit('setPoints', data);
        },
    }
};
